import React, { useEffect } from 'react';
import './InfoToast.css';

const InfoToast = ({ message, onClose, duration = 4000 }) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="info-toast">
            <span className="info-toast-icon">ℹ️</span>
            <span className="info-toast-message">{message}</span>
            <button className="info-toast-close" onClick={onClose}>✕</button>
        </div>
    );
};

export default InfoToast;